import { FaWhatsapp } from "react-icons/fa";
import "./wsp_flotante.css";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/51958966927" //(código país + número)
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
}
